import { IFileTemplate, IFlowTemplate } from '../../../types/model.types';

export enum FlowPanel {
    Most_used_templates = 'Most_used_templates',
    Recently_sent_flows = 'Recently_sent_flows',
    All_flow_templates = 'All_flow_templates',
    Suggested_templates = 'Suggested_templates',
    Visit_flow_gallery = 'Visit_flow_gallery',
    Starred_templates = 'Starred_templates',
    My_flows = 'My_flows',
    Folder_templates = 'Folder_templates'
}

export type TFlowPanel = keyof typeof FlowPanel;

export enum SortBy {
    DateAsc = 'date-asc',
    DateDesc = 'date-desc',
    NameAsc = 'name-asc'
}

export type TSortBy = keyof typeof SortBy;

export type TFlowActionType =
    | 'invoice'
    | 'contract'
    | 'questionnaire'
    | 'services'
    | 'starred'
    | 'schedule'
    | 'scheduler'
    | 'recurring_invoice';

export type TProjectListFilters = {
    participantsEmails?: string[];
};

export type TBlockComponentsFilterByBlockTypes =
    | 'question_block'
    | 'text_block'
    | 'video_block'
    | 'image_block'
    | 'spacer_block';

export enum FlowActionFilterType {
    Invoice = 'invoice',
    Contract = 'contract',
    Ouestionnaire = 'questionnaire',
    Services = 'services',
    Starred = 'starred',
    Scheduler = 'schedule'
}

export type TEntryPoint =
    | 'files'
    | '+new'
    | 'home'
    | 'workspace'
    | 'project-send-file'
    | 'contact_list'
    | 'contact_view_create_file'
    | 'contracts' // TODO: this is for the empty state, not existing in the codebase
    | 'my-templates' // TODO: this is for the pdf button on templates, not existing in the codebase
    | 'chat'; // TODO: this is for the AIChat, not existing in the codebase

export interface ICreateFlowData {
    appPath?: string;
    project_id?: string;
    event_name?: string;
    workspaceId?: string;
    workspace_id?: string;
    flows: IFlowTemplate[];
    filters?: TFlowActionType[];
    projectListFilters?: TProjectListFilters;
    onClose: Function;
    clientId?: string;
    isNavBarScoped?: boolean;
    source?: string;
    entry_point?: TEntryPoint;
}

export type TCardSize = 'lg' | 'md';

export interface IProject {
    _id: string;
    event_name: string;
    created_at: string;
    updated_at?: string;
}

export type ITemplateCard = IFlowTemplateCard | IFileTemplate;
export interface IFlowTemplateCard extends IFlowTemplate {
    project?: IProject;
}

export interface IFlowPanelData {
    sectionType: TFlowPanel;
    title: string;
    sectionIcon: JSX.Element;
    ctaText?: string;
    analytics?: {
        sourceName: string;
    };
}

export type TRequestStatus =
    | 'idle'
    | 'initial_loading'
    | 'filtering'
    | 'fetching'
    | 'creating'
    | 'succeeded'
    | 'failed';

export enum FlowTemplateAction {
    Duplicate = 'Duplicate',
    UseTemplate = 'UseTemplate',
    Starred = 'Starred',
    Move = 'Move',
    Delete = 'Delete',
    Share = 'Share',
    ViewLive = 'ViewLive'
}

export type TFlowTemplateAction = keyof typeof FlowTemplateAction;

export interface IFlowFilterByAction {
    key: TFlowActionType;
    label: string;
    isActive: boolean;
}

export interface ISidebarMenuItem {
    text: string;
    icon?: JSX.Element;
    onClick: (val?: TFlowPanel | null) => void;
    isActive?: boolean;
    defaultFill?: boolean;
}

export type TFlowTypeFilter = 'template' | 'flow' | 'all' | 'public_flow';

export type TImportPDFFileType = 'invoice' | 'contract' | 'other';

export interface TFetchCompanyFlows {
    companyId: string;
    filters?: TFlowActionType[];
    flow_type?: TFlowTypeFilter;
    folder_id?: string;
}
